import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  Button,
  ModalBody,
  Text,
  Divider,
  Box,
} from "@chakra-ui/react";
import { IrmaoTable } from "../../pages/Criancas/ReferenciaFamiliar/Irmaos/Table";
import { format } from "date-fns";

import CriancaService from "../../../main/services/CriancaService";
import LoadingSpinner from "../LoadingSpinner";
import SemRegistros from "../SemRegistros";

const HistoricoApadrinhamento = ({
  isOpen,
  onClose,
  idCrianca,
  atualizarApadrinhamento,
  cadastrarApadrinhamento,
}) => {
  const [historicoApadrinhamento, setHistoricoApadrinhamento] = useState(null);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      Header: "Nome",
      accessor: "nomePessoaApadrinhamento",
      Cell: (props) => {
        const nomePessoaApadrinhamento = props?.value;

        return (
          <span>
            {nomePessoaApadrinhamento ? nomePessoaApadrinhamento : ""}
          </span>
        );
      },
    },
    {
      Header: "Tipo",
      accessor: "tipoPessoaProgApadrinha",
      Cell: (props) => {
        const tipo = props?.value;

        return (
          <span>
            {tipo === "P"
              ? "Padrinho (Programa)"
              : tipo === "M"
              ? "Madrinha (Programa)"
              : ""}
          </span>
        );
      },
    },
    {
      Header: "Data Início",
      accessor: "dataInicioApadrinhamento",
      Cell: (props) => {
        const dataInicioApadrinhamento = props?.value;

        return (
          <span>
            {dataInicioApadrinhamento
              ? format(new Date(dataInicioApadrinhamento), "dd/MM/yyyy")
              : ""}
          </span>
        );
      },
    },
    {
      Header: "Data Fim",
      accessor: "dataFimApadrinhamento",
      Cell: (props) => {
        const dataFimApadrinhamento = props?.value;

        return (
          <span>
            {dataFimApadrinhamento
              ? format(new Date(dataFimApadrinhamento), "dd/MM/yyyy")
              : ""}
          </span>
        );
      },
    },

    {
      Header: "Informações Complementares",
      accessor: "informacaoComplementar",
      Cell: (props) => {
        const informacaoComplementar = props?.value;

        return (
          <span>{informacaoComplementar ? informacaoComplementar : ""}</span>
        );
      },
    },
  ];

  useEffect(() => {
    CriancaService.getCriancaApadrinhamentoHistorico(idCrianca)
      .then((res) => {
        setLoading(true);
        if (res.data) {
          setHistoricoApadrinhamento(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [
    idCrianca,
    setHistoricoApadrinhamento,
    atualizarApadrinhamento,
    cadastrarApadrinhamento,
  ]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="6xl"
      scrollBehavior={"inside"}
    >
      <ModalOverlay />
      <ModalContent
        p={{ base: "5px", sm: "15px", md: "25px" }}
        w={{ base: "100%", lg: "70%" }}
        bgColor="#FFF"
      >
        <ModalHeader>
          <Text
            fontWeight={700}
            fontSize="16px"
            lineHeight="21.6px"
            color="#169499"
          >
            {"Histórico de Apadrinhamento".toUpperCase()}
          </Text>
        </ModalHeader>
        {!loading ? (
          <ModalBody p="0px" minH={{ base: "0px", md: "200px" }} pl="1px">
            <Divider
              mt={"0px"}
              orientation="horizontal"
              borderColor={"#DDEBEA"}
            />

            {historicoApadrinhamento?.pessoasProgramaApadrinhamento &&
            historicoApadrinhamento?.pessoasProgramaApadrinhamento.length >
              0 ? (
              <IrmaoTable
                mt={"14px"}
                columns={columns}
                data={historicoApadrinhamento?.pessoasProgramaApadrinhamento}
                filiacoes={historicoApadrinhamento}
                idCrianca={idCrianca}
                entidade={"apadrinhamento"}
                disableHeaderOptionsOpcoes={true}
              />
            ) : (
              <Box mt={4}>
                <SemRegistros buttonVisible={true} half />
              </Box>
            )}
          </ModalBody>
        ) : (
          <LoadingSpinner />
        )}

        <Divider mt={"20px"} orientation="horizontal" borderColor={"#DDEBEA"} />
        <ModalFooter display={"flex"}>
          <Button
            onClick={onClose}
            color="#FFF"
            backgroundColor="#169499"
            fontWeight={700}
            px={"10"}
            fontSize="15px"
            lineHeight="21.6px"
            _hover={{ bg: "#169499" }}
          >
            Voltar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default HistoricoApadrinhamento;
